export const RETAIL_META_DESCRIPTION_BG =
  "Медиен мониторинг и медийни анализи за компании в търговията на дребно в Югоизточна Европа - кампании, конкуренти, потребителски нагласи и анализ на репутацията.";
